var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"error","text":"","data-method":"delete","dense":""},on:{"click":_vm.logout}},[_c('v-icon',[_vm._v(" mdi-logout ")]),_vm._v("\n  ログアウト\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }